export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13116.ab6b1b41.jpg";